import script from "./SelectOption.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectOption.vue?vue&type=script&setup=true&lang=js"

import "./SelectOption.vue?vue&type=style&index=0&id=5eb01fd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb01fd3"]])

export default __exports__